const data = {
  id: 0,
  curation: require("./3/curation").default,
};

export default data;
